import { RootState } from '../reducer';

export const selectCommonState = (state: RootState) => state.common;

export const selectAlertMessages = (state: RootState) => state.common.alert.messages;

export const selectHasAlertMessages = (state: RootState) => state.common.alert.messages.length > 0;
